import { defineMessages } from 'react-intl';

export default defineMessages({
    addNewDriver: {
        id: 'wmic-pe-capability-gateway-common-pa-react.components.WMICAddNewDriverButton.WMICAddNewDriverButton.addNewDriver',
        defaultMessage: 'Add New Driver',
    }
})